import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-784e5a39"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_3 = { class: "container-area" }
const _hoisted_4 = { class: "table-area" }
const _hoisted_5 = { class: "d-flex justify-content--center align-items-center" }
const _hoisted_6 = { class: "card-header d-flex justify-content--between" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "加班类型占比", -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode("按时长")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("按条目")
const _hoisted_10 = {
  id: "pieChart",
  style: {"min-height":"280px","height":"100%"}
}

import { ref, computed, reactive, onMounted, nextTick, isShallow } from 'vue'
import dayjs from 'dayjs'
import { useStore } from 'vuex'
import { ElMessage, ElMessageBox, formatter } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { getNumber } from '@/utils/index'
import Api from '@/http/modules/index'
import * as echarts from "echarts";
import store from '@/store/index'
import { overflow } from 'html2canvas/dist/types/css/property-descriptors/overflow'
import JsBarcode from 'jsbarcode'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {
    //下拉框选项
    'GET/pay_pool/drop_list': drapListApi,
    // 加班报表_类型下拉框
    'GET/work_overtime/type_drop_list':typeDropListApi,
    // 加班报表_报表
    'POST/work_overtime/report':workOvertimeApi,
    // 加班报表_用户加班时长分页查询
    'POST/work_overtime/report/users':reportUsersApi,
    // 获取财务岗位下拉
    'GET/user_finances': financialJobListApi,
    // 部门列表（树状）
  'GET/departments/tree': departmentsTreeApi,
} = Api
const tableHeight=window.innerHeight-190
const tableLoading=ref(false)
const queryForm=ref<any>({
    overtime:[dayjs().subtract(1,'year'),dayjs()]
})
const isShow=ref(true)
const workOverTimeList=ref([])
const departmentList=ref([])
const pieChartCount=ref<any>({})
const pieChartTime=ref<any>({})
const typeList=ref([])
const financialJobList=ref([])
const pageInfo=reactive({
    page:1,
    size:30,
    total:0
})
const rankTableList=ref([])
const rankTableListLoading=ref(false)
const rankingPageInfo=reactive({
    page:1,
    size:30,
    total:0
})
const overtimeType=ref('1')
const  pieChartTotalCount=ref(0)
const  pieChartTotalTime=ref(0)
// isReset 判断是否是重置操作，isRanking控制获取是否是加班排名的数据
const getWorkOvertime=(isReset:boolean=false,isRanking:boolean=false)=>{
    if(isReset){
        if(isRanking){
           rankingPageInfo.page=1 
        }else{
           pageInfo.page=1 
        }       
        queryForm.value={
            overtime:[dayjs().subtract(1,'year'),dayjs()]
        }
    }
    let {name,orgId,companyId,departmentId,type,overtime,financeStationId}=queryForm.value
    // let {page,size}=pageInfo
    let params={name,orgId,companyId,departmentId:departmentId&&departmentId.length?departmentId[departmentId.length-1]:'',type,page:isRanking?rankingPageInfo.page:pageInfo.page,size:isRanking?rankingPageInfo.size:pageInfo.size,financeStationId,
        workOverTimeStart:overtime&&overtime.length?dayjs(overtime[0]).format("YYYY-MM-DD"):'' ,
        workOverTimeEnd:overtime&&overtime.length?dayjs(overtime[1]).format("YYYY-MM-DD"):'' ,
    }
    tableLoading.value=!isRanking||false
    rankTableListLoading.value=isRanking||false
    let methodApi=isRanking?reportUsersApi:workOvertimeApi
    methodApi(params).then((res:any)=>{
        if(!isRanking){ //加班报表数据
            workOverTimeList.value=res.page.data
            pageInfo.total=res.page.rowCount
            pieChartCount.value=res.pieChartCount
            pieChartTime.value=res.pieChartTime 
            pieChartTotalCount.value=res.pieChartTotalCount
            pieChartTotalTime.value=res.pieChartTotalTime
            nextTick(()=>{
                initEchart()
            })
        }else{ //加班排名
            rankTableList.value=res.data
            rankingPageInfo.total=res.rowCount
        }      
    }).finally(()=>{
        tableLoading.value=false
        rankTableListLoading.value=false
    })
}
const searchHandle=(isReset:boolean=false)=>{
    pageInfo.page=1 //搜索时页码为1
    getWorkOvertime(isReset)
    getWorkOvertime(false,true)
}
const initEchart=()=>{    
    let targetData:any=overtimeType.value=='1'?pieChartTime.value:pieChartCount.value
    targetData.forEach((el:any)=>{
        el.value=overtimeType.value=='1'?el.hours:el.count
    })
    let pieOption ={
        tooltip: {
            trigger: 'item',
            confine: true,
            formatter:(params:any)=>{
                return `${params.name}${changeNumber(params.value,overtimeType.value=='1'?2:0)} ${overtimeType.value=='1'?'h':'条'}`
            },
        },
        legend: {
            data: targetData.map((el:any)=>el.name),
            orient: 'vertical', // 垂直排列
            x: '50%', // 图例在右边
            y:'5%',
            itemStyle:{
                borderRadius:50
            },
            icon: 'circle',
            formatter:(name:any)=>{
                let res:any= targetData.find((el:any)=>el.name==name)
                return `{name| ${name}} {val| ${changeNumber(res.value,overtimeType.value=='1'?2:0)}} {type| ${overtimeType.value=='1'?'h':'条'}}`
            },
            textStyle:{
                rich:{
                    name:{
                        width:160,
                        // color:"#fff"
                    },
                }
            }            
        },  
        series: [ 
            {
                name: '',
                type: 'pie',
                radius: ['50%', '65%'],
                center: ['25%', '50%'],
                avoidLabelOverlap: false,
                hoverAnimation:true,
                itemStyle: {
                    borderRadius: 0,
                    borderColor: '#fff',
                    borderWidth: 1,
                },
                label: {
                    show: true,
                    position: 'center',
                    animation: false,
                    formatter:()=>{
                        return [`{d|${overtimeType.value=='1'?'加班时长':'总条数'}}`,`{value|${overtimeType.value=='1'?getNumber(pieChartTotalTime.value)+'h':changeNumber(pieChartTotalCount.value,0)}}`].join("\n")
                    },
                    rich:{
                        d:{
                            fontSize:14,
                            color:"#9a9a9a",
                            padding:[0,0,10,0]
                        },
                        value:{
                            fontSize:24,
                            color:'#000'
                        }
                    }
                },
                labelLine: {
                    show: false
                },
                data:targetData
            }
        ],
    }
    var pieChart = echarts.init(document.getElementById('pieChart'));
    pieChart.setOption(pieOption,true)
}
const setIndex=(index:any)=>{
    const page = rankingPageInfo.page // 当前页码
    const pagesize = rankingPageInfo.size // 每页条数
    return index + 1 + (page - 1) * pagesize
}
const changeNumber=(value:any,num:any)=>{
    return parseFloat(value).toLocaleString('zh', {
        minimumFractionDigits: num,
        maximumFractionDigits: num,
    })
}
onMounted(()=>{
    departmentsTreeApi().then((res: any) => {
        departmentList.value = res
    })
    typeDropListApi().then((res:any)=>{
        typeList.value=res
    })
    financialJobListApi().then((res:any)=>{
        financialJobList.value=res
    })    
    searchHandle()
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_DArrowRight = _resolveComponent("DArrowRight")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_DArrowLeft = _resolveComponent("DArrowLeft")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_card = _resolveComponent("el-card")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_collapse, { class: "mb-10" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, {
          title: "搜索",
          name: "1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              class: "searchContent searchBg",
              model: queryForm.value,
              style: {"padding-top":"26px"},
              "label-width": "90px",
              inline: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "姓名:",
                  prop: "name"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: queryForm.value.name,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.value.name) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "团队:",
                  prop: "orgId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      placeholder: "请选择团队",
                      modelValue: queryForm.value.orgId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.value.orgId) = $event)),
                      filterable: "",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).getters.sysOrganizations, (org) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: org.name,
                            value: org.id,
                            key: org.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "公司:",
                  prop: "companyId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: queryForm.value.companyId,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.value.companyId) = $event)),
                      style: {"width":"310px"},
                      filterable: "",
                      placeholder: "请选择公司"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).getters.sysCompany, (group) => {
                          return (_openBlock(), _createBlock(_component_el_option_group, {
                            label: group.label,
                            key: group.label
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (comp) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  label: comp.name,
                                  value: comp.id,
                                  key: comp.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "部门:",
                  prop: "departmentId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_cascader, {
                      clearable: "",
                      modelValue: queryForm.value.departmentId,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.value.departmentId) = $event)),
                      options: departmentList.value,
                      props: { label: 'name', value: 'departmentId' }
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "类型:",
                  prop: "type"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: queryForm.value.type,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.value.type) = $event)),
                      placeholder: "选择一项",
                      clearable: "",
                      class: "form-input"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeList.value, (item, idx) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: idx,
                            label: item,
                            value: item
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "财务岗位:",
                  prop: "financeStationId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: queryForm.value.financeStationId,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.value.financeStationId) = $event)),
                      placeholder: "选择一项",
                      clearable: "",
                      class: "form-input"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(financialJobList.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "开始日期:",
                  prop: "overtime"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: queryForm.value.overtime,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((queryForm.value.overtime) = $event)),
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": " ",
                      "end-placeholder": " "
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (searchHandle())),
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (searchHandle(true) ))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          class: "mb-10",
          height: tableHeight+'px',
          border: "",
          data: workOverTimeList.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "姓名",
              prop: "userName",
              width: "180",
              fixed: "left"
            }),
            _createVNode(_component_el_table_column, {
              label: "团队",
              prop: "orgName",
              width: "180"
            }),
            _createVNode(_component_el_table_column, {
              label: "公司",
              prop: "companyName",
              width: "180",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "部门",
              prop: "departmentName",
              width: "150"
            }),
            _createVNode(_component_el_table_column, {
              label: "加班情况",
              align: "center",
              width: "180"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "类型",
                  prop: "type",
                  width: "180"
                }),
                _createVNode(_component_el_table_column, {
                  label: "开始时间",
                  prop: "newBegin",
                  width: "180",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "结束时间",
                  prop: "newEnd",
                  width: "180",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "时长",
                  prop: "totalTime",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  label: "事由",
                  prop: "note",
                  width: "180"
                }),
                _createVNode(_component_el_table_column, {
                  label: "审批人",
                  width: "180",
                  prop: "approvalNameList",
                  formatter: (row)=>row.approvalNameList.join(',')
                }, null, 8, ["formatter"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["height", "data"])), [
          [_directive_loading, tableLoading.value]
        ]),
        _createVNode(_component_el_pagination, {
          background: "",
          small: "",
          "current-page": _unref(pageInfo).page,
          "onUpdate:current-page": _cache[9] || (_cache[9] = ($event: any) => ((_unref(pageInfo).page) = $event)),
          "page-size": _unref(pageInfo).size,
          "onUpdate:page-size": _cache[10] || (_cache[10] = ($event: any) => ((_unref(pageInfo).size) = $event)),
          "page-sizes": [30, 60, 100, 120],
          layout: "sizes, prev, pager, next,total",
          total: _unref(pageInfo).total,
          onSizeChange: _cache[11] || (_cache[11] = ()=>getWorkOvertime()),
          onCurrentChange: _cache[12] || (_cache[12] = ()=>getWorkOvertime())
        }, null, 8, ["current-page", "page-size", "total"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "contrl-btn",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (isShow.value=!isShow.value))
        }, [
          _withDirectives(_createVNode(_component_el_icon, { class: "animation-slide" }, {
            default: _withCtx(() => [
              _createVNode(_component_DArrowRight)
            ]),
            _: 1
          }, 512), [
            [_vShow, isShow.value]
          ]),
          _withDirectives(_createVNode(_component_el_icon, { class: "animation-slide" }, {
            default: _withCtx(() => [
              _createVNode(_component_DArrowLeft)
            ]),
            _: 1
          }, 512), [
            [_vShow, !isShow.value]
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass({'echart-area':true,'echart-area-hidden':isShow.value?false:true})
      }, [
        _createVNode(_component_el_card, {
          shadow: "never",
          style: {"min-width":"540px"}
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_el_radio_group, {
                onChange: _cache[14] || (_cache[14] = ($event: any) => (initEchart())),
                size: "small",
                modelValue: overtimeType.value,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((overtimeType).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_button, { label: "1" }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio_button, { label: "2" }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_10, null, 512), [
              [_directive_loading, tableLoading.value]
            ])
          ]),
          _: 1
        }),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          style: {"width":"100%"},
          class: "mb-10 mt-10",
          "max-height": tableHeight-394+'px',
          border: "",
          data: rankTableList.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "序号",
              type: "index",
              index: setIndex,
              width: "55"
            }),
            _createVNode(_component_el_table_column, {
              label: "姓名",
              prop: "name"
            }),
            _createVNode(_component_el_table_column, {
              label: "团队",
              prop: "orgName",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "公司",
              prop: "companyName",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "部门",
              prop: "departmentName",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "总时长(h)",
              prop: "hours"
            })
          ]),
          _: 1
        }, 8, ["max-height", "data"])), [
          [_directive_loading, rankTableListLoading.value]
        ]),
        _createVNode(_component_el_pagination, {
          background: "",
          small: "",
          "current-page": _unref(rankingPageInfo).page,
          "onUpdate:current-page": _cache[16] || (_cache[16] = ($event: any) => ((_unref(rankingPageInfo).page) = $event)),
          "page-size": _unref(rankingPageInfo).size,
          "onUpdate:page-size": _cache[17] || (_cache[17] = ($event: any) => ((_unref(rankingPageInfo).size) = $event)),
          "page-sizes": [30, 60, 100, 120],
          layout: "sizes, prev, pager, next,total",
          total: _unref(rankingPageInfo).total,
          onSizeChange: _cache[18] || (_cache[18] = ()=>getWorkOvertime(false,true)),
          onCurrentChange: _cache[19] || (_cache[19] = ()=>getWorkOvertime(false,true))
        }, null, 8, ["current-page", "page-size", "total"])
      ], 2)
    ])
  ], 64))
}
}

})